<script>
  import { onMount, createEventDispatcher, onDestroy } from 'svelte';

  import Autocomplete from '@app-components/Autocomplete.svelte';

  import UserPossibleGroupIdeaAjax from '@ajax/user_possible_group_idea';
  import Log from '@utils/log';
  import Track from '@utils/track';
  import Mixpanel from '@utils/mixpanel';

  import jQuery from 'jquery';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let showBackBtn = true;
  export let displayAutofill;
  export let currentUser;
  export let group;

  export let selectOnlyCategories = false;
  export let selectedIdea;
  export let selectedCategory;

  let loading = true;
  let ideas = [];
  let keepFetchingInterval;
  let unableToLoad = false;

  let selectedCategoryIndex = 0;
  $: selectedCategory =
    selectedIdea &&
    selectedIdea.data &&
    selectedIdea.data.categories &&
    selectedIdea.data.categories[selectedCategoryIndex];

  let startIndex = 0;
  const shownAtOnce = 3;

  let loadData = async function () {
    unableToLoad = false;

    if (selectOnlyCategories) {
      loading = false;
    } else {
      loading = true;
      ideas = await UserPossibleGroupIdeaAjax.index();
      loading = false;

      if (ideas.length === 0) {
        keepFetching();
      }
    }
  };

  let keepFetching = function () {
    let times = 0;

    keepFetchingInterval = setInterval(async () => {
      ideas = await UserPossibleGroupIdeaAjax.index();
      times += 1;

      if (ideas.length > 0) {
        clearInterval(keepFetchingInterval);
        return;
      }

      if (times >= 120) {
        unableToLoad = true;
        clearInterval(keepFetchingInterval);
      }
    }, 1000);
  };

  let reload = function () {
    if (selectedIdea) {
      log(`refreshed "${selectedIdea.title}" rec suggestion (${selectedCategory})`);

      if (selectedCategoryIndex >= selectedIdea.data.categories.length - 1) {
        selectedCategoryIndex = 0;
      } else {
        selectedCategoryIndex += 1;
      }

      jQuery('#select-recommendation-input').focus();
      Mixpanel.track('Refresh Generated Rec Question', { 'Group ID': group && group.id });

      return;
    }

    if (ideas.length === 0) {
      return;
    }

    if (startIndex * shownAtOnce + shownAtOnce >= ideas.length) {
      startIndex = 0;
    } else {
      startIndex += 1;
    }

    Mixpanel.track('Refresh Generated List Ideas', { 'Group ID': group && group.id });
    log('refreshed list ideas');
  };

  let selectIdea = function (idea) {
    dispatch('create-list', { idea: idea });

    log(`selected list idea "${idea.title}"`);
    Mixpanel.track('Select Generated List Idea', { 'Group ID': group && group.id });
    Track.generatedListSelectListIdea({ currentUser: currentUser, listIdea: idea.title });
  };

  let unselectIdea = function () {
    selectedIdea = undefined;
  };

  let goBack = function () {
    if (selectedIdea && !selectOnlyCategories) {
      Mixpanel.track('Back Generated Rec Question', { 'Group ID': group && group.id });
      unselectIdea();
    } else {
      Mixpanel.track('Back Generated List Ideas', { 'Group ID': group && group.id });
      dispatch('back');
    }
  };

  let log = function (msg) {
    if (currentUser && currentUser.id) {
      Log.info(`${currentUser.name} ${msg} (${currentUser.profile_url})`, false, '#generated-lists');
    }
  };

  onMount(() => {
    loadData();
    log(`viewed list ideas`);
  });

  onDestroy(() => {
    clearInterval(keepFetchingInterval);
  });
</script>

<style style="text/scss" lang="scss">
  .group-ideas-builder-header {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding-left: 20px;
    position: relative;
    margin-bottom: 20px;
    user-select: none;

    .group-ideas-builder-header-refresh {
      border-radius: 999px;
      background: #f5f5f5;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      user-select: none;

      &:hover {
        background: #dcdcdc;
      }
    }

    .selected-idea-back {
      position: absolute;
      left: 0px;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .group-ideas-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 12px;

    .not-generated {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #777;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;

      i {
        color: #7054dc;
        font-size: 24px;
      }
    }

    .group-idea-container {
      display: flex;
      gap: 20px;
      border-radius: 16px;
      border: 2px solid #ececec;
      background: #fff;
      width: 100%;
      padding: 12px;
      cursor: pointer;

      &:hover {
        border: 2px solid #a893f9;
        background-color: #eae4ff;
      }

      .group-idea-img {
        width: 72px;
        height: 72px;
        background: #f5f3fc;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .group-idea-img {
        font-size: 32px;
      }

      .group-idea-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;

        .group-idea-title {
          font-size: 18px;
          font-weight: 500;
          line-height: 26px;
          color: #1a1a1a;
        }

        .group-idea-subtitle {
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: #7f7f7f;
        }
      }

      .group-idea-arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 4px;
      }
    }
  }

  .group-ideas-add-container {
    margin-top: 60px;
    user-select: none;

    .group-ideas-add-title {
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      min-height: 64px;

      b {
        color: #159089;
      }
    }

    .group-ideas-add-input {
      margin-top: 28px;
    }
  }

  .group-idea-loading {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 80px;
    color: #8e71ff;
    font-size: 22px;
  }

  .mobile {
    .selected-idea-back {
      left: -6px;
    }
  }
</style>

<div class="group-ideas-builder-header" class:mobile={mobile}>
  {#if selectedIdea || showBackBtn}
    <div class="selected-idea-back" on:click={goBack}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.7682 14.5802C12.1218 14.0852 12.0645 13.3495 11.6402 12.9371L6.56205 8L11.6402 3.06295C12.0645 2.65046 12.1218 1.9148 11.7682 1.41981C11.4147 0.924825 10.7841 0.857947 10.3598 1.27044L4.35982 7.10375C4.13182 7.3254 4 7.65376 4 8C4 8.34624 4.13182 8.6746 4.35982 8.89625L10.3598 14.7296C10.7841 15.1421 11.4147 15.0752 11.7682 14.5802Z"
          fill="black" />
      </svg>
    </div>
  {/if}

  <div>Ideas</div>

  <div class="group-ideas-builder-header-refresh" on:click={reload}>
    <img
      src="/images/group-ideas/refresh.png"
      srcset="/images/group-ideas/refresh.png 1x, /images/group-ideas/refresh@2x.png 2x" />
  </div>
</div>

<div class:mobile={mobile}>
  {#if loading}
    <div class="group-idea-loading"><i class="fa fa-spinner fa-spin" /></div>
  {:else if unableToLoad}
    <div class="group-ideas-container">
      <div class="not-generated">Unable to load ideas. Please try again later.</div>
    </div>
  {:else if selectedIdea}
    <div class="group-ideas-add-container">
      <div class="group-ideas-add-title">What's your favorite <b>{selectedCategory}?</b></div>
      <div class="group-ideas-add-input">
        <Autocomplete
          focus={true}
          closeOnBlur={true}
          width={'100%'}
          height={300}
          placeholder="Enter {selectedCategory} name or link"
          on:selected={(e) => {
            displayAutofill(e.detail.term);
            Track.generatedRecSubmitAnswer({
              currentUser: currentUser,
              group: group,
              listIdea: selectedIdea.title,
              listIdeaAnswer: e.detail.term,
            });
            Mixpanel.track('Autofill Rec from Question', { 'Group ID': group && group.id });
          }} />
      </div>
    </div>
  {:else}
    <div class="group-ideas-container">
      {#if ideas.length == 0}
        <div class="not-generated">
          <i class="fa fa-spin fa-spinner" style="margin-bottom: 30px;" /><br />
          Ideas are still being generated.<br />This could take up to a minute.
        </div>
      {/if}

      {#each ideas.slice(startIndex * shownAtOnce, startIndex * shownAtOnce + shownAtOnce) as idea}
        <div class="group-idea-container" on:click={() => selectIdea(idea)}>
          <div class="group-idea-img">{idea.emoji}</div>
          <div class="group-idea-text">
            <div class="group-idea-title">{idea.title}</div>
          </div>
          <div class="group-idea-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.23178 1.41981C3.87821 1.9148 3.93554 2.65046 4.35982 3.06295L9.43795 8L4.35982 12.9371C3.93554 13.3495 3.87821 14.0852 4.23178 14.5802C4.58534 15.0752 5.21591 15.1421 5.64018 14.7296L11.6402 8.89625C11.8682 8.6746 12 8.34624 12 8C12 7.65376 11.8682 7.3254 11.6402 7.10375L5.64018 1.27044C5.21591 0.857947 4.58534 0.924825 4.23178 1.41981Z"
                fill="#1A1A1A" />
            </svg>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>
